<content-loader
  [backgroundColor]="'var(--skeletonLoader-bgColor)'"
  [foregroundColor]="'var(--bgColor-neutral-muted)'"
  [baseUrl]="baseUrl"
  [speed]="3"
  [viewBox]="viewBox"
>
  <ng-content></ng-content>
</content-loader>
